import { render, staticRenderFns } from "./CallBtn.vue?vue&type=template&id=6c3203d0&"
import script from "./CallBtn.vue?vue&type=script&lang=ts&"
export * from "./CallBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports